import type { Plugin } from '@nuxt/types';

import type { AlgoliaSearchContext, AlgoliaSearchModuleOptions } from './types';

declare module 'vue/types/vue' {
  interface Vue {
    $algoliaSearch: AlgoliaSearchContext;
  }
}

declare module '@nuxt/types' {
  interface Context {
    $algoliaSearch: AlgoliaSearchContext;
  }
}

const algoliaSearchPlugin: Plugin = (_context, inject) => {
  const options = JSON.parse('{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d","envName":"live","contentfulPagesEnvName":"master","localeConfigs":{"en_eu":{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d"},"fr_fr":{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d"},"fr_eu":{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d"},"es_eu":{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d"},"it_eu":{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d"},"de_eu":{"appId":"K7R9CFQSJ4","apiKey":"7e9d8b36aa4292221b0b64a633da4b1d","analyticsApiKey":"4c6a6f230981fb8b8654143a31f69a5d"},"en_us":{"appId":"JTZYOGT0H6","apiKey":"d41f9d5488ae2ee8dd505ff5ac22cada","analyticsApiKey":"4b5bf1edb1e30649d4c2a73da86b32f1"},"fr_us":{"appId":"JTZYOGT0H6","apiKey":"d41f9d5488ae2ee8dd505ff5ac22cada","analyticsApiKey":"4b5bf1edb1e30649d4c2a73da86b32f1"},"ja_jp":{"appId":"KXWL4191C8","apiKey":"095a03a8686421f925e350d7b6666a6b","analyticsApiKey":"f7be59f31a0e5bc0f9b4dc0c8e57bcc1"},"en_hk":{"appId":"KXWL4191C8","apiKey":"095a03a8686421f925e350d7b6666a6b","analyticsApiKey":"f7be59f31a0e5bc0f9b4dc0c8e57bcc1"},"zh_hk":{"appId":"KXWL4191C8","apiKey":"095a03a8686421f925e350d7b6666a6b","analyticsApiKey":"f7be59f31a0e5bc0f9b4dc0c8e57bcc1"}}}') as AlgoliaSearchModuleOptions;
  const {
    appId: defaultAppId,
    apiKey: defaultApiKey,
    analyticsApiKey: defaultAnalyticsApiKey,
    envName,
    contentfulPagesEnvName,
    localeConfigs = {}
  } = options;

  inject('algoliaSearch', {
    defaultAppId,
    defaultApiKey,
    defaultAnalyticsApiKey,
    envName,
    contentfulPagesEnvName,
    localeConfigs
  });
};

export default algoliaSearchPlugin;
